import DashBoardNav from '@/layout/DashBoardNav'

export default [{
  path: '/mappoint',
  component: DashBoardNav,
  children: [{
    path: '/mappoint',
    component: () => import('@/components/home/mappoint.vue')
  },
  ]
}]
